import { scrollbarCompensate } from '../scrollbar-compensate';
import { create_widgets } from '../widgets/create_widgets';
import Modal from '../lib/modals/Modal';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import togglePasswordFieldType from '../toggle-password-field-type';

/*
elements = {
    overlay: HTML element
    modal_window: HTML element
    modal_content: HTML element
    close_button: HTML element
}
*/

class BaseModal extends Modal {
  constructor(
    elements,
    contentProvider,
    settings = {
      display_before_content_load: false,
    },
  ) {
    super(
      Object.assign({}, elements, { html: document.querySelector('html') }),
      contentProvider,
      settings,
    );
  }

  close() {
    this.currentModal.hideModal();
  }

  showModal() {
    const onTransitionEnd = () => {
      this.elements.overlay.classList.add('modal-interactable'); // pointer-events: all;
      if (typeof this.elements.overlay.focus !== 'undefined') {
        this.elements.overlay.focus(); // focus only window
      }
      this.elements.overlay.removeEventListener(
        'transitionend',
        onTransitionEnd,
      );
    };
    this.elements.overlay.addEventListener('transitionend', onTransitionEnd);
    this.elements.overlay.setAttribute('aria-hidden', 'false');
    this.elements.overlay.classList.add('modal-rendered'); // display: block na modal
    this.elements.html.classList.add('noscroll'); // overflow: hidden na body
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.elements.overlay.classList.add('modal-visible'); // opacity: 1 na modal
      });
    });
    scrollbarCompensate.compensate(); // add margin if needed
    disableBodyScroll(this.elements.overlay.querySelector('.modal-scroll-wrap'));
  }

  hideModal() {
    const onTransitionEnd = () => {
      this.elements.overlay.classList.remove('modal-rendered');
      this.clearContent();
      this.elements.html.classList.remove('noscroll');
      scrollbarCompensate.reset();
      this.uninit();
      this.unsetModalStyle();
      this.elements.overlay.removeEventListener(
        'transitionend',
        onTransitionEnd,
      );
    };
    this.elements.overlay.addEventListener('transitionend', onTransitionEnd);
    this.elements.overlay.classList.remove('modal-visible');
    this.elements.overlay.classList.remove('modal-interactable');
    this.elements.overlay.setAttribute('aria-hidden', 'true');
    enableBodyScroll(this.elements.overlay.querySelector('.modal-scroll-wrap'));
  }

  initContent() {
    if (this.elements.modal_content.querySelector('.js-modal-close')) {
      this.elements.modal_content
        .querySelectorAll('.js-modal-close')
        .forEach(element => {
          element.addEventListener('click', eventObj => {
            eventObj.preventDefault();
            this.close();
          });
        });
    }
    create_widgets(this.elements.modal_content);

    togglePasswordFieldType(this.elements.modal_content.querySelectorAll('.passwordInputField__Wrapper'));
  }
}

export default BaseModal;



// WEBPACK FOOTER //
// ./src/js/modals/BaseModal.js